import React from 'react';
import Hero from './hero';
import About from './about';
import Solutions from './solutions';
import ContactUs from './contactUs';
import Team from './team';
import VideoBanner from './videoBanner';


export default function Home() {
    return (<>
        <Hero/>
        <About/>
        <Solutions/>
        <VideoBanner/>
        <Team/>
        <ContactUs/>
    </>);
}
